import { setConfig } from '../config';

const { config } = setConfig();

export const { API } = config;
export const API_KEY = 'AIzaSyCajAf3o0KDGBm1g8RF2FheMJaIsKXfPCY';
